import { render, staticRenderFns } from "./RastreoEnvio.vue?vue&type=template&id=b1285b6c&scoped=true"
import script from "./RastreoEnvio.vue?vue&type=script&lang=js"
export * from "./RastreoEnvio.vue?vue&type=script&lang=js"
import style0 from "./RastreoEnvio.vue?vue&type=style&index=0&id=b1285b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1285b6c",
  null
  
)

export default component.exports